<template>
  <div class="artificial-service overflow-y-auto" v-loading="artificialLoading">
    <div class="sample-box" v-if="loadEnd">
      <ItemContainer v-for="(item, index) in allData" :key="index" :ref="'ItemContainer' + (index + 1)" :title="`第 ${index + 1} 次样本服务`" class="mb-4">
        <!-- 服务前 -->
        <div class="flex">
          <div class="ball"></div>
          <div class="title">支付样本服务费用</div>
        </div>
        <div class="flex pt-2" ref="sample">
          <div class="line"></div>
          <div :style="{width: 'calc(100% - 21px)'}">
            <DataTable
              :border="true"
              :data="item.pushList"
              :showTooltip="false"
              :columns="push1Columns"
              :header-cell-style="{ background:'#f5f5f5', color:'rgba(0,0,0,0.45)'}"
              :showPage="false"/>
            <div class="text-medium leading-26 text-theme-black-850 text-right mr-4">红包总金额(元) ： <span class="text-medium font-bold">{{item.discountReward}}</span></div>
            <div class="text-medium leading-26 text-theme-black-850 text-right mr-4">服务费 <span class="text-small text-theme-black-650">({{Math.floor(item.serviceRate * 100)}}%)</span> (元)： <span class="text-medium font-bold">{{item.serviceFee}}</span></div>
            <div class="text-medium leading-26 text-theme-black-850 text-right mr-4">合计费用(元)： <span class="text-medium-x font-bold">{{item.totalAmount}}</span></div>
            <div class="pt-4 pb-6 flex justify-between" v-if="item.status === 0">
              <div class="text-small leading-18 text-theme-black-450">请确认本次样本服务内容，付款后代表您已确认如上信息，请知晓。有相关疑问可                 
                <el-popover placement="top-start" trigger="hover">
                  <div style="width: 200px; height: 200px">
                    <img src="/assets/img/code/Mrs.Chai.png" class="w-full h-full" />
                  </div>
                  <span class="text-theme cursor-pointer" slot="reference">联系客服</span>
                </el-popover>
              </div>
              <el-button type="danger" class="text-medium-x font-bold" @click="openPaymentDialog(item, index)"><span class="text-medium font-normal">去支付</span> {{item.totalAmount}}</el-button>
            </div>
          </div>
        </div>
        <!-- 服务中 -->
        <div class="flex">
          <div class="ball"></div>
          <div class="title">样本服务中 <span class="text-small text-theme-black-450">(可随时审核答卷)</span></div>
        </div>
        <div class="flex pt-2" v-if="item.status !== 0">
          <div class="line" v-if="item.status === 3"></div>
          <div v-if="item.status === 1" class="text-small font-semibold text-yellow-theme leading-18 ml-5">调研工厂正在为您回收数据中，1～3 个工作日会陆续把回收的答卷发送给您审核</div>
          <DataTable
            v-else
            :class="['pb-6', item.status < 3 ? 'ml-5' : '']"
            ref="sampling"
            :style="{width: 'calc(100% - 21px)'}"
            :border="true"
            :showTooltip="false"
            :data="item.pushList"
            :columns="push2Columns"
            :header-cell-style="{ background:'#f5f5f5', color:'rgba(0,0,0,0.45)'}"
            :showPage="false">
          <template #recoveredAmount="{ row }">
            <div @click="openJumpDialog(row, index)" class="text-theme cursor-pointer">{{ row.recoveredAmount }}</div>
          </template>
          <template #refusedAmount="{ row }">
            <div @click="openJumpDialog(row, index)" class="text-theme cursor-pointer">{{ row.refusedAmount }}</div>
          </template>
          <template #auditedAmount="{ row }">
            <div @click="openJumpDialog(row, index)" class="text-theme cursor-pointer">{{ row.auditedAmount }}</div>
          </template>
          <template #auditingAmount="{ row }">
            <div @click="openJumpDialog(row, index)" class="text-theme cursor-pointer">{{ row.auditingAmount }}</div>
          </template>
          <template #spentAmount="{ row }">
            <div>{{ row.spentAmount || 0 }}</div>
          </template>
          <template #balanceAmount="{ row }">
            <div>{{ row.balanceAmount || 0 }}</div>
          </template>
          </DataTable>
        </div>
        <!-- 服务后 -->
        <div class="flex" v-if="item.status === 3">
          <div class="ball"></div>
          <div class="title">样本服务已完成</div>
        </div>
        <div class="pt-1 ml-5 text-small text-theme-black-850 leading-18" v-if="item.status === 3">如需开具发票，请 
          <el-popover placement="top-start" trigger="hover">
            <div style="width: 200px; height: 200px">
              <img src="/assets/img/code/Mrs.Chai.png" class="w-full h-full" />
            </div>
            <span class="text-theme cursor-pointer" slot="reference">联系客服</span>
          </el-popover>
        </div>
        <!-- 退钱 -->
        <div v-if="item.status === 3 && item.refundAmount !== 0">
          <DataTable
            class="ml-5 mt-2"
            :border="true"
            :showTooltip="false"
            :data="item.pushList"
            :columns="push3Columns"
            :header-cell-style="{ background:'#f5f5f5', color:'rgba(0,0,0,0.45)'}"
            :showPage="false"/>
          <div class="text-medium leading-26 text-theme-black-850 text-right mr-4">退款红包总额(元) ： <span class="text-medium font-bold">{{item.refundReward}}</span></div>
          <div class="text-medium leading-26 text-theme-black-850 text-right mr-4">服务费 <span class="text-small text-theme-black-650">({{Math.floor(item.serviceRate * 100)}}%)</span> (元)： <span class="text-medium font-bold">{{item.refundFee}}</span></div>
          <div class="text-medium leading-26 text-theme-black-850 text-right mr-4">合计退款费用(元)： <span class="text-medium-x font-bold">{{item.refundAmount}}</span></div>
        </div>
      </ItemContainer>
    </div>

    <!-- 确认支付 -->
    <el-dialog
      title="确认支付"
      :visible.sync="paymentDialog"
      width="520px"
      top="20vh"
      :before-close="handleClosePayment"
      :destroy-on-close="true">
      <div class="dialog flex bg-card-bg-gray">
        <!-- 支付 -->
        <div :style="{width: isPersonal ? '100%' : '330px', height: '236px'}" class="relative text-medium text-theme-black-850 leading-22 bg-white">
          <el-row class="pt-4 pb-3">
            <el-col :span="isPersonal ? 6 : 10"><div class="pl-4 text-right">交易明细：</div></el-col>
            <el-col :span="isPersonal ? 18 : 14"><div class="text-theme-black-650">第{{paymentIndex}}次样本服务</div></el-col>
          </el-row>
          <el-row class="pb-3">
            <el-col :span="isPersonal ? 6 : 10"><div class="pl-4 text-right">支付金额：</div></el-col>
            <el-col :span="isPersonal ? 18 : 14"><div class="text-theme-black-650">{{paymentNum}} 元</div></el-col>
          </el-row>
          <el-row>
            <el-col :span="isPersonal ? 6 : 10"><div class="pl-4 text-right">支付方式：</div></el-col>
            <el-col :span="isPersonal ? 18 : 14">
              <i class="icon-danxuanti text-medium text-theme leading-22"></i>
              <span class="text-theme"> 账户余额（<span :class="notEnoughBalance ? 'text-red' : ''">{{balance}}</span>）</span>
            </el-col>
          </el-row>
          <el-row v-if="!isAdmin">
            <div class="pr-2 pt-1 text-right text-small leading-22 font-semibold text-red">您没有支付权限，请向企业管理员提交支付审批</div>
          </el-row>
          <el-row v-else-if="notEnoughBalance">
            <el-col :span="isPersonal ? 6 : 10"><div class="pl-4">&nbsp;</div></el-col>
            <el-col :span="isPersonal ? 18 : 14"><div class="pt-1 text-small leading-22 font-semibold text-yellow-theme">可用红包余额不足，请先 <span class="text-theme cursor-pointer" @click="onClickGoRechargeOld">去充值</span></div></el-col>
          </el-row>
          <div class="absolute bottom-0 right-0 w-full">
            <div class="line-dialog"></div>
            <div class="m-4 text-right">
              <el-button @click="handleClosePayment">取 消</el-button>
              <span class="ml-3">
                <el-button v-if="isAdmin" type="primary" @click="surePayment" :disabled="notEnoughBalance">确认支付</el-button>
                <el-button v-else-if="!isAdmin" type="primary" @click="submitApproval">提交审批</el-button>
              </span>
            </div>
          </div>
        </div>
        <!-- 客服 -->
        <div class="m-4 mt-0 bg-white" style="width: 158px;" v-if="!isPersonal">
          <div class="title">联系客服</div>
          <div class="subTitle">如有疑问可联系客服</div>
          <img src="/assets/img/code/Mrs.Chai.png" alt="" width="126" class="p-4 pt-0" />
        </div>
      </div>
    </el-dialog>

    <!-- 跳转窗口 -->
    <el-dialog
      :title="jumpTitle"
      :visible.sync="jumpDialog"
      width="50%"
      top="24px"
      :before-close="handleCloseJump">
      <div class="text-center">
        <div class="py-6 text-20 leading-22 font-semibold text-theme-black-850">审核回收样本操作说明</div>
        <img :src="`${baseUrl}img/data_review.png`" class="w-full h-full box-border px-10"/>
        <div class="w-full h-px bg-black opacity-10 mt-6"></div>
        <div class="text-right">
          <el-button @click="handleCloseJump" class="normal-button">取消</el-button>
          <el-button class="my-4 mr-4" type="primary" @click="toAuditData">去审核</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 提交审批窗口 -->
    <el-dialog
      class="theme-dialog dialog-center dialog-body-0"
      top="0"
      title="提交审批"
      :visible.sync="approvalDialogVisible"
      width="50%"
      :before-close="approvalCloseDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true">
      <approval-submit
        v-if="approvalDialogVisible"
        :payment-info="paymentItem"
        @submit="onSubmitApproval"
        @cancel="approvalCloseDialog"/>
    </el-dialog>

    <!-- 支付等待窗口 -->
    <el-dialog
      class="theme-dialog dialog-center dialog-body-0"
      top="0"
      title="充值结果"
      :visible.sync="resultPay"
      width="50%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="false"
      :append-to-body="true"
      :modal-append-to-body="true"
      :before-close="beforeCloseDialog">
      <result-payment @success="onClickSuccess" @error="onClickError" />
    </el-dialog>
  </div>
</template>

<script>
import GlobalConfig from '@/global/config'
import DataTable from '@/components/base/DataTable'
import { isPersonal } from '@/assets/js/config/env'
import { getMainUrl } from '@/mixins/getRechargeUrl'
import { getEnvelopes } from '@/api/wenjuan/publish'
import rechargeMixin from '@/mixins/recharge-mixins'
import { getJurisdiction } from '@/api/wenjuan/reward'
import { getYuE, confirmPay } from '@/api/wenjuan/reward'
import { saveSurveySetting } from '@/api/wenjuan/publish'
import ItemContainer from '@/components/base/ItemContainer'
import { push1Columns, push2Columns, push3Columns} from './config'
import { querySampleServiceByUser } from "@/api/wenjuan/sampleService"
import ResultPayment from '@/components/envelopes/resultPayment/result-payment'
import ApprovalSubmit from '@/components/envelopes/approval-submit/approval-submit'

export default {
  name: "ArtificialService",
  mixins: [rechargeMixin],
  components: { ItemContainer, DataTable, ResultPayment, ApprovalSubmit },
  data() {
    return {
      isPersonal,
      loadEnd: false,
      artificialLoading: true,
      push1Columns,
      push2Columns,
      push3Columns,
      paymentDialog: false, // 支付窗口
      balance: 0.00, // 余额
      paymentNum: 0, // 支付金额
      paymentIndex: 0, // 第几次样本服务
      paymentItem: {}, // 支付对象
      allData: [], // 全部列表数据
      jumpTitle: '', // 跳转窗口的标题
      jumpDialog: false,
      resultPay: false, // 支付等待窗口
      approvalDialogVisible: false, // 审批窗口
      isPaymentSuccess: false, // 充值成功的标记
      redAuditInfo: null, //支付审批流程
      timer: null
    }
  },
  computed: {
    isAdmin() {
      return (GlobalConfig.getCompanyId() === '0' || this.$store.getters.userInfo?.isAdmin === 1)
    },
    notEnoughBalance() {
      return this.balance < this.paymentItem.totalAmount
    }
  },
  methods: {
    // 去充值
    onClickGoRechargeOld() {
      const data = {
        orderNo: '', // 充值未用到流水号
        charge: this.paymentItem.totalAmount
      }
      this.chargeHandler(data, () => {
        this.resultPay = true
        this.paymentDialog = false
      })
    },
    // 充值成功的回调
    rechargeSuccess() {
      this.resultPay = false
      this.isPaymentSuccess = true
      this.getBalance()
      this.paymentDialog = true
      if(this.notEnoughBalance) {
        this.$message.error('余额不足，请再次充值')
        return
      }
      this.surePayment()
    },
    // 充值失败的回调
    handelPaymentError() {
      this.resultPay = false
      this.paymentDialog = true
      this.$message.error('您未支付成功')
    },
    // 用户点击充值失败
    onClickError() {
      this.$message.error('您未支付成功')
      this.resultPay = false
      this.getBalance()
      this.paymentDialog = true
    },
    // 用户点击充值成功
    onClickSuccess() {
      const loading = this.$loading({
        lock: true,
        text: '正在获取结果',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      this.timer = setTimeout(() => {
        if (!this.isPaymentSuccess) {
          this.$message.error('您未支付成功')
          loading.close()
          this.resultPay = false
          this.getBalance()
          this.paymentDialog = true
        }
        clearTimeout(this.timer)
      }, 5000)
    },
    // 关闭支付等待窗口
    beforeCloseDialog() {
      this.resultPay = false
    },
    // 成功提交审批
    onSubmitApproval() {
      this.$message.success('已提交审批，审批通过后金额会自动支付')
      this.approvalCloseDialog()
    },
    // 关闭审批窗口
    approvalCloseDialog() {
      this.approvalDialogVisible = false
      this.handleClosePayment()
    },
    // 打开提交审批的弹窗
    submitApproval() {
      if(this.redAuditInfo) {
        this.$message.error('您已提交审批，请等待审批结果')
        return
      }
      this.approvalDialogVisible = true
    },
    handleCloseJump() {
      this.jumpDialog = false
    },
    // 打开跳转弹窗
    openJumpDialog(row, index) {
      this.jumpTitle = `第${index+1}次样本服务`
      this.jumpDialog = true
    },
    // 跳转到审核
    toAuditData() {
      this.$router.push(`/survey/${GlobalConfig.getSurveyId()}/data/data-examine/pending-review`)
    },
    // 打开支付窗口
    openPaymentDialog(item, index) {
      this.paymentDialog = true
      this.paymentNum = item.totalAmount
      this.paymentIndex = index + 1
      this.paymentItem = item
      // 判断样本状态
      if(item.awardId) {
        // 查询支付红包
        getEnvelopes(item.awardId).then(res => {
          if(res.data.code !== 0) return
          this.paymentItem.awardId = res.data.data.id
          this.redAuditInfo = res.data.data.redAuditInfo // 查询的haul需要给审批流程赋值
        }).catch((err) => {console.log(err)})
      } else {
        // 创建支付红包
        let data = {
          quantity: item.demandRecoveryQuantity,
          amount: item.pushList[0].discountReward,
          surveyId: GlobalConfig.getSurveyId(),
          awardType: 1,
          orderSource: 4,
          randomRedEnvelope: 0,
          totalAmount: item.totalAmount,
          sampleServiceFee: item.serviceFee,
          sampleServiceId: item.id,
          note: '',
        }
        item.pushList.forEach((item, index) => {
          if(index !== 0) data.note += ','
          data.note += item.note
        })
        getJurisdiction(data).then(res => {
          if(res.data.code !== 0) return
          this.paymentItem.awardId = res.data.data.awardId
          this.redAuditInfo = null
        }).catch((err) => {console.log(err)})
      }
    },
    // 确认支付的事件
    surePayment() {
      const loading = this.$loading({
        lock: true,
        text: '正在支付',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      let item = this.paymentItem
      let data = {
        awardId: item.awardId,
        amount: item.discountReward,
        quantity: item.demandRecoveryQuantity,
        orderSource: 4,
        sampleServiceFee: item.serviceFee,
        sampleServiceId: item.id,
        total: item.totalAmount,
        surveyId: GlobalConfig.getSurveyId()
      }
      confirmPay(data).then(res => {
        if(res.data.code !== 0) {
          this.$message.error(res.data.msg)
          this.timer = setTimeout(() => {
            clearTimeout(this.timer)
            this.handleClosePayment()
            loading.close()
            this.getDataList()
          }, 1000)
          return
        }
        let data = {
          id: GlobalConfig.getSurveyId(),
          otherSetting: {editSubmit: false}
        }
        saveSurveySetting(data).then(red => {
          if(red.data.code !== 0) return
          this.$message.success('支付成功')
          this.handleClosePayment()
          this.getDataList()
        }).finally(() => {loading.close()})
      }).catch((err) => {console.log(err)})
    },
    // 关闭支付窗口
    handleClosePayment() {
      this.paymentDialog = false
    },
    // 获取列表信息
    async getDataList() {
      this.artificialLoading = true
      await querySampleServiceByUser(GlobalConfig.getSurveyId()).then(res => {
        if(res.data.code !== 0) return
        this.allData = res.data.data
      }).catch((err) => {console.log(err)})
      .finally(() => {
        this.artificialLoading = false
        this.loadEnd = true
      })
    },
    // 获取余额
    async getBalance() {
      await getYuE().then(res => {
        if(res.data.code !== 0) return
        this.balance = res.data.data
      }).catch((err) => {console.log(err)})
    }
  },
  created() {
    this.getDataList()
    this.getBalance()
  }
}
</script>

<style scoped lang="scss">
.leading-26 {
  line-height: 26px;
}
.artificial-service {
  height: calc(100% - 35px);
  ::v-deep .sample-box {
    .item-container {
      &:last-child {
        @apply mb-0;
      }
      .el-card:nth-child(1) {
        @apply mb-0;
      }
    }
  }
  .ball {
    @apply rounded-full mr-3 mt-1.5 bg-ccc;
    width: 9px;
    height: 9px;
  }
  .title {
    @apply font-semibold text-medium text-theme-black-850 leading-22;
    font-family: PingFangSC-Medium;
  }
  .line {
    @apply w-px bg-ccc mr-4 ml-1 -mt-4 -mb-2;
  }
}

::v-deep .item-container {
  .el-card {
    @apply mx-0 mt-0;
  }
}
::v-deep .el-table__header-wrapper {
  .sort-table-header-row {
    @apply bg-card-bg-gray;
    .cell {
      @apply text-theme-black-450;
    }
  }
}
::v-deep .el-dialog__header {
  background: #F5F7FA;
  @apply px-4 py-3;
}
::v-deep .el-dialog__body {
  @apply p-0 bg-card-bg-gray;
  .line-dialog {
    @apply h-px bg-black opacity-10;
  }
  .title {
    @apply font-semibold text-medium-x leading-22 text-theme-black-850 pt-4 pl-4;
    font-family: PingFangSC-Medium;
    &::before {
      content: '';
      @apply w-1 h-5 bg-theme inline-block float-left -ml-4;
    }
  }
  .subTitle {
    @apply text-theme-black-650 text-medium leading-22 text-center py-2;
    font-family: PingFangSC-Regular;
  }
}
::v-deep .el-dialog__body {
  @apply bg-white;
}
</style>
